<template>
	<v-row>
		<v-col>
			<v-card outlined>
				<v-card-title
					class = "justify-center info pa-0 body-1 success white--text"
				>
					<v-icon
						small
						class = "mx-2"
						color = "white"
					>
						mdi-whatsapp
					</v-icon>
					<span>
						{{ $ml.get('whatsapp') }}
					</span>
					
				</v-card-title>
				<v-card-text
					class = "pa-1 mt-1"
				>
					<v-row>
						<template v-for = "(item_info, idx_info) of info_fields">
							
							<v-col
								:md  = "6"
								:key = "idx_info"
							>
								<v-text-field
									dense
									outlined
									hide-details
									v-show 	  = "item_info.enable"
									:type 	  = "item_info.type"
									v-model   = "info[item_info.key]"
									:label 	  = "$ml.get(item_info.text)"
									v-if 	  = "['number', 'text'].includes(item_info.type)"
								></v-text-field>

								<v-card outlined 
									class  	  = "pa-0 caption pb-1 pl-1" 
									height 	  = "40"
									v-else-if = "item_info.type == 'switch'"
								>
									<v-switch			
										dense						
										false-value
										hide-details
										class 			= "mt-1"			
										v-model 		= "info[item_info.key]"						
										:label 			= "$ml.get(item_info.text)"
										:prepend-icon 	= "item_info.icon"
									></v-switch>
										<!-- v-if="item_field.type == 'switch'"						 -->
										<!-- class="pt-0" -->
								</v-card>

							</v-col>
						</template>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-progress-linear
				      	indeterminate
				      	v-show = "loading"
				      	color  = "success"
				    ></v-progress-linear>
					<v-btn
						x-small
						@click = "save"
						color  = "primary"
						v-text = "$ml.get('update')"
				      	v-show = "!loading"						
					></v-btn>
					<v-spacer></v-spacer>
					<v-btn
						x-small
						@click = "actions('confirm_delete')"
						color  = "error"
						v-text = "$ml.get('delete')"
				      	v-show = "!loading"
					></v-btn>
					
					
				</v-card-actions>
			</v-card>
		</v-col>
	</v-row>
</template>
<script>
	export default{
		name : 'whatsapp',
		data : (vm) => ({
			info : {

			},
			info_fields : [
				{
					key : 'name',
					text : 'name',
					type : 'text',
					enable : true,

				},
				{
					key : 'enable',
					text : 'enable',
					type : 'switch',
					enable : true,				
				},
				{
					key : 'url',
					text : 'url',
					type : 'text',
					enable : false,
				},
				{
					key : 'port',
					text : 'port',
					type : 'number',
					enable : false,
				},

			],
			builder 		: ['name', 'enable', 'url', 'port'],
			id_notification : 'whatsapp',
			bus 			: {},
			loading 		: false,

		}), // data

		created(){
			this.get_list();
			
			if (this.$route.name == 'parameters') {
				if (this.$store.state && this.$store.state.auth && this.$store.state.auth.user){
					if(this.$store.state.auth.user.user.roleId == 1){
			       		let vn = this;
			       		vn.info_fields.forEach( (itm)=>{
			       			if (itm && !itm.enable) {
			       				itm.enable = true;
			       			}
			       		})
			      		
			      	}
			    }
			}

		}, // created
		
		methods :{
			
			actions(act, item, opt){
				if (act == 'confirm_delete') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : this.id_notification,
					});
				}

			}, // actions

			get_list(){
				const api    = this.$URL + '/api/v1/whatsapp/' + 1;
				const api1   = this.$URL + '/api/v1/whatsapp';
				this.loading = true;
				this.$axios.get( api).then( res => {
					this.loading = false;
					if (res && res.data) {
						this.info = res.data;
					}else{
						let info_up = {
							name      : "default",
					        enable    : false,
					        url       : "http://190.60.120.136:9191/alerts",
					        port      : "9191",
						}
						this.$axios.post(api1, info_up).then(ress =>{
							if (ress && ress.data) {
								this.info = info_up;								
							}
						}).catch(err => {
							console.log("error create whatsapp ", err);
							this.$EventBus.$emit('notifications_modal',{
								type 	: 'error',
								message : err 
							});			
						})
						console.log("Not found info whatsapp", res);
					}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // get list
			
			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/whatsapp/' + 1;
				let info_up  = this.$Helper.format_req(this.info, this.builder);
				if (info_up && info_up.name && info_up.url) {

					this.loading = true;				
					this.$axios.put( api, info_up).then( res => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type : 'updated'
						});
					}).catch( er => {
						this.loading = false;
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						});
					});
				}else{
					let msg = '';
					if (!info_up.name) {
						msg += this.$ml.get('name');
					}
					if (!info_up.url) {
						msg += msg ?  ', ' : '';
						msg += this.$ml.get('url');
					}
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'warning',
						message : this.$ml.get('required') + ' : ' + msg
					})
				}
			}, // save

			del(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const api    = this.$URL + '/api/v1/whatsapp/' + 1;				
				this.loading = true;
				this.$axios.delete( api).then( res => {
					this.loading = false;

					this.$EventBus.$emit('notifications_modal',{
						type : 'deleted'
					});
					this.info = {
						name      : "default",
				        enable    : false,
				        url       : "http://190.60.120.136:9191/alerts",
				        port      : "9191",
					};
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // del

		}, // methods

		mounted(){
			let temp_bus = "notifications_modal" + this.id_notification;
			this.$EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					this.del();
				}
			});
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(this.$EventBus, this.bus, 'whatsapp');

		}, // beforeDestroy

	};
</script>